import { render, staticRenderFns } from "./editTeamDialog.vue?vue&type=template&id=453931ea&scoped=true"
import script from "./editTeamDialog.vue?vue&type=script&lang=js"
export * from "./editTeamDialog.vue?vue&type=script&lang=js"
import style0 from "./editTeamDialog.vue?vue&type=style&index=0&id=453931ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453931ea",
  null
  
)

export default component.exports